/* ==========================================================================
   kb-product-page.js
   Cabinet product page (template: product.cabinet_product). Works alongside the theme's own
   product script (theme.js) and only adds:
     - "Your kitchen range" line (from what the customer picked on the kitchen style page)
     - Kitchen Range + Carcass Colour saved with the cart line (line item properties)
     - a clear "choose a carcass colour" step when the customer arrives without one chosen
     - price shown ex VAT with inc VAT underneath, kept right when the variant changes
     - a sticky price + Add to Cart bar on phones and tablets
   ========================================================================== */
(function () {
  if (window.__kbpInit) return;
  window.__kbpInit = true;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function ls(key) { try { return localStorage.getItem(key) || ''; } catch (e) { return ''; } }

  /* ---------- money (same formats the theme supports) ---------- */
  function formatMoney(cents, format) {
    format = format || (window.theme && window.theme.moneyFormat) || '£{{amount}}';
    function num(value, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision; thousands = thousands || ','; decimal = decimal || '.';
      var n = (value / 100).toFixed(precision).split('.');
      return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (n[1] ? decimal + n[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, name) {
      switch (name) {
        case 'amount_no_decimals': return num(cents, 0);
        case 'amount_with_comma_separator': return num(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return num(cents, 2, "'", '.');
        default: return num(cents, 2);
      }
    });
  }

  var root, needChoice = false, sticky, stickyPrice, stickyBtn;

  /* ---------- 1. kitchen range line ---------- */
  function initRange() {
    var box = $('[data-kbp-range]', root);
    var name = ls('builder:KbName') || ls('builder:doorStyle');
    if (box && name) {
      $('[data-kbp-range-name]', box).textContent = name;
      var img = $('[data-kbp-range-img]', box);
      var src = ls('builder:KbDoorImage');
      if (img && src) { img.src = src; img.hidden = false; img.addEventListener('error', function () { img.hidden = true; }); }
      box.hidden = false;
    }
    // saved with the cart line
    var prop = $('[data-kbp-prop="range"]', root);
    if (prop && name) { prop.value = name; prop.disabled = false; }
  }

  /* ---------- 2. carcass colour: required choice + property ---------- */
  function colourRadios() { return $$('[data-kbp-colour] .product-form__single-selector', root); }
  function visibleColourRadios() { return colourRadios().filter(function (r) { var w = r.closest('.kbp-sw'); return !(w && w.hidden); }); }

  function syncColourProp() {
    var prop = $('[data-kbp-prop="colour"]', root);
    if (!prop) return;
    var checked = colourRadios().filter(function (r) { return r.checked; })[0];
    if (checked) { prop.value = checked.getAttribute('data-kbp-colour-name') || checked.value; prop.disabled = false; }
    else { prop.value = ''; prop.disabled = true; }
  }

  function clearColourError() {
    var wrap = $('[data-kbp-colour]', root);
    if (!wrap) return;
    wrap.classList.remove('is-error', 'is-shake');
    var msg = $('[data-kbp-msg]', wrap); if (msg) msg.hidden = true;
  }

  function initColour() {
    var radios = colourRadios();
    if (!radios.length) return;
    var arrivedWithVariant = /[?&]variant=\d+/.test(window.location.search);
    needChoice = visibleColourRadios().length > 1 && !arrivedWithVariant;
    // Arrived without choosing (for example straight from search): nothing is ticked, the customer must choose.
    if (needChoice) radios.forEach(function (r) { r.checked = false; });
    var req = $('[data-kbp-req]', root); if (req) req.hidden = !needChoice;
    syncColourProp();
  }

  function showColourError() {
    var wrap = $('[data-kbp-colour]', root);
    if (!wrap) return;
    var msg = $('[data-kbp-msg]', wrap); if (msg) msg.hidden = false;
    wrap.classList.add('is-error');
    wrap.classList.remove('is-shake'); void wrap.offsetWidth; wrap.classList.add('is-shake');
    var first = visibleColourRadios()[0];
    if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
    if (wrap.scrollIntoView) wrap.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  /* ---------- 3. price (ex VAT / inc VAT switch) ---------- */
  var vatMode = 'ex', curPrice = 0, curCompare = 0;

  function priceHtml(price, compare) {
    var ex = Math.round(price / 1.2), exOn = vatMode === 'ex';
    var main = exOn ? ex : price, alt = exOn ? price : ex;
    var mainCompare = compare > price ? (exOn ? Math.round(compare / 1.2) : compare) : 0;
    var was = mainCompare ? '<s class="kbp-price__was">' + formatMoney(mainCompare) + '</s> ' : '';
    return '<span class="price kbp-price__ex">' + was + '<span class="kbp-price__amount">' + formatMoney(main) + '</span> <em>' + (exOn ? 'Ex VAT' : 'Inc VAT') + '</em></span>' +
           '<span class="kbp-price__inc">' + formatMoney(alt) + (exOn ? ' inc VAT' : ' ex VAT') + '</span>';
  }
  function paintPrice() {
    var el = $('[data-kbp-price]', root);
    if (!el || !curPrice) return;
    el.innerHTML = priceHtml(curPrice, curCompare);
    if (stickyPrice) {
      stickyPrice.textContent = formatMoney(vatMode === 'ex' ? Math.round(curPrice / 1.2) : curPrice);
      var lbl = $('span', stickyPrice.parentNode); if (lbl) lbl.textContent = vatMode === 'ex' ? 'ex VAT' : 'inc VAT';
    }
    $$('[data-kbp-vat]', root).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-kbp-vat') === vatMode)); });
  }
  function renderPrice(variant) {
    if (!variant) return;
    curPrice = variant.price; curCompare = variant.compare_at_price || 0;
    paintPrice();
  }
  function initPrice() {
    var el = $('[data-kbp-price]', root);
    if (!el) return;
    curPrice = parseInt(el.getAttribute('data-price'), 10) || 0;
    curCompare = parseInt(el.getAttribute('data-compare'), 10) || 0;
  }

  /* ---------- 4. sticky buy bar (phones / tablets) ---------- */
  function initSticky() {
    var main = $('.product-form__add-button', root);
    if (!main) return;
    var amount = $('.kbp-price__amount', root);
    sticky = document.createElement('div');
    sticky.className = 'kbp-sticky';
    sticky.innerHTML = '<div class="kbp-sticky__price"><b></b><span>ex VAT</span></div><button type="button" class="kbp-sticky__btn">Add to Cart</button>';
    document.body.appendChild(sticky);
    document.body.classList.add('kbp-has-sticky');
    stickyPrice = $('b', sticky);
    stickyBtn = $('button', sticky);
    stickyPrice.textContent = amount ? amount.textContent : '';
    stickyBtn.addEventListener('click', function () {
      var btn = $('.product-form__add-button', root);
      if (btn && !btn.disabled) btn.click();
    });
    function syncDisabled() { var btn = $('.product-form__add-button', root); stickyBtn.disabled = !btn || btn.disabled; }
    syncDisabled();
    if (window.MutationObserver) {
      new MutationObserver(syncDisabled).observe(main, { attributes: true, attributeFilter: ['disabled'] });
    }
    // show the bar once the main Add to cart button has scrolled out of view
    var ticking = false;
    function updateSticky() {
      ticking = false;
      var btn = $('.product-form__add-button', root);
      if (!btn) return;
      sticky.classList.toggle('is-show', btn.getBoundingClientRect().bottom < 0);
    }
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(updateSticky); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    updateSticky();
  }


  /* ---------- 5. description: highlights, key facts and sections ---------- */
  function textOf(html) { var d = document.createElement('div'); d.innerHTML = html; return (d.textContent || '').replace(/\s+/g, ' ').trim(); }

  // turn the description into a flat list of "units": lists, tables and single lines (<br> splits lines)
  function flatten(node, out) {
    Array.prototype.slice.call(node.childNodes).forEach(function (n) {
      if (n.nodeType === 3) { var t = n.textContent.replace(/\s+/g, ' ').trim(); if (t) out.push({ kind: 'line', html: t, text: t }); return; }
      if (n.nodeType !== 1) return;
      var tag = n.tagName;
      if (tag === 'UL' || tag === 'OL') { out.push({ kind: 'list', node: n, items: $$('li', n) }); return; }
      if (tag === 'TABLE') { out.push({ kind: 'table', node: n }); return; }
      if (tag === 'DIV' && (n.querySelector('ul, ol, table, p'))) { flatten(n, out); return; }
      n.innerHTML.split(/<br\s*\/?>/i).forEach(function (part) {
        var html = part.trim(); if (!html) return;
        var text = textOf(html); if (!text) return;
        out.push({ kind: 'line', html: html, raw: part, text: text, heading: /^H[1-6]$/.test(tag) });
      });
    });
    return out;
  }
  function addRow(rows, text) {
    var m = text.match(/^\s*([^:]{1,70}?)\s*:\s*(.+)$/);
    if (m && m[2].trim()) rows.push([m[1].trim(), m[2].replace(/\s+/g, ' ').trim()]);
  }
  function parseRows(units) {
    var rows = [];
    units.forEach(function (u) {
      if (u.kind === 'list') u.items.forEach(function (li) { addRow(rows, (li.textContent || '').replace(/\s+/g, ' ').trim()); });
      else if (u.kind === 'table') $$('tr', u.node).forEach(function (tr) { var c = $$('th, td', tr); if (c.length >= 2) rows.push([c[0].textContent.trim(), c[1].textContent.replace(/\s+/g, ' ').trim()]); });
      else if (u.raw && /\n/.test(u.raw.trim())) u.raw.split(/\n/).forEach(function (l) { addRow(rows, textOf(l)); }); // lines separated by line breaks in the text
      else addRow(rows, u.text);
    });
    return rows;
  }
  function unitsToHtml(units) {
    var html = '', buf = [];
    function flush() { if (buf.length) { html += '<p>' + buf.join('<br>') + '</p>'; buf = []; } }
    units.forEach(function (u) {
      if (u.kind === 'list' || u.kind === 'table') { flush(); html += u.node.outerHTML; }
      else if (u.heading) { flush(); html += '<h4>' + u.html + '</h4>'; }
      else buf.push(u.html);
    });
    flush();
    return html;
  }
  function section(title, bodyEl, open) {
    var d = document.createElement('details'); d.className = 'kbp-acc__item'; if (open) d.open = true;
    var s = document.createElement('summary'); s.textContent = title; d.appendChild(s);
    var b = document.createElement('div'); b.className = 'kbp-acc__body'; b.appendChild(bodyEl); d.appendChild(b);
    return d;
  }
  function tile(row) {
    var label = row[0].replace(/\(.*?\)/g, '').trim(), value = row[1];
    if (/\(mm\)/i.test(row[0]) && /^\d+(\.\d+)?$/.test(value)) value += ' mm';
    return [label, value];
  }

  function initDescription() {
    var item = $('.kbp-below .product-block-list__item--description');
    var rte = item && $('.rte', item);
    if (!rte) return;
    var units = flatten(rte, []);
    var si = -1;
    units.forEach(function (u, i) { if (si < 0 && u.kind === 'line' && /^specifications?\s*:?$/i.test(u.text)) si = i; });

    var descUnits = si < 0 ? units : units.slice(0, si);
    var rows = si < 0 ? [] : parseRows(units.slice(si + 1));
    if (si >= 0 && rows.length < 2) return; // heading found but the lines are not "Label: value": leave the page as it is

    // highlights: the description starts with a bullet list
    var hl = $('[data-kbp-highlights]', root);
    if (hl && descUnits[0] && descUnits[0].kind === 'list') {
      descUnits[0].items.slice(0, 3).forEach(function (li) { var t = (li.textContent || '').replace(/\s+/g, ' ').trim(); if (t) { var e = document.createElement('li'); e.textContent = t; hl.appendChild(e); } });
      if (hl.children.length) hl.hidden = false;
    }

    // key facts (the cabinet page prints its own from the dimensions field)
    var facts = $('[data-kbp-facts]', root);
    if (facts && rows.length) {
      var find = function (re) { return rows.filter(function (r) { return re.test(r[0]); })[0]; };
      var tiles = [find(/^height\b/i), find(/^width\b/i), find(/^depth\b/i)];
      if (!tiles.every(Boolean)) tiles = [find(/^finish\b/i), find(/^style\b/i), find(/^range\b/i)].filter(Boolean);
      if (tiles.length >= 2) {
        tiles.slice(0, 3).forEach(function (r) {
          var t = tile(r), box = document.createElement('div'); box.className = 'kbp-fact';
          var k = document.createElement('span'); k.className = 'kbp-fact__k'; k.textContent = t[0];
          var v = document.createElement('span'); v.className = 'kbp-fact__v'; v.textContent = t[1];
          box.appendChild(k); box.appendChild(v); facts.appendChild(box);
        });
        facts.hidden = false;
      }
    }

    // sections
    var wrap = document.createElement('div'); wrap.className = 'kbp-acc';
    var descBody = document.createElement('div');
    descBody.innerHTML = si < 0 ? rte.innerHTML : unitsToHtml(descUnits);
    if (descBody.textContent.trim() || descBody.querySelector('img, table, ul, ol')) wrap.appendChild(section('Description', descBody, true));
    if (rows.length >= 2) {
      var table = document.createElement('table'); table.className = 'kbp-spec' + (rows.length > 9 ? ' kbp-spec--cols' : '');
      var tb = document.createElement('tbody');
      rows.forEach(function (r) {
        var tr = document.createElement('tr'), th = document.createElement('th'), td = document.createElement('td');
        th.setAttribute('scope', 'row'); th.textContent = r[0]; td.textContent = r[1]; tr.appendChild(th); tr.appendChild(td); tb.appendChild(tr);
      });
      table.appendChild(tb);
      wrap.appendChild(section('Specification', table, true));
      var trust = $('[data-kbp-trust]', root);
      if (trust) {
        var it = document.createElement('div'); it.className = 'kbp-trust__item';
        it.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 3h9l4 4v14H6z"/><path d="M15 3v4h4M9 12h6M9 16h6"/></svg><span>Full specification below</span>';
        trust.appendChild(it);
      }
    }
    if (!wrap.children.length) return;
    item.parentNode.insertBefore(wrap, item);
    item.parentNode.removeChild(item);
  }


  /* ---------- 6. options: never leave the customer on a combination that does not exist ---------- */
  var adjusting = false;
  function productData() {
    var el = $('[data-product-json]', root);
    try { return el ? JSON.parse(el.textContent).product : null; } catch (e) { return null; }
  }
  function inputsFor(pos, visibleOnly) {
    return $$('.product-form__single-selector[data-option-position="' + pos + '"]', root)
      .filter(function (i) { return !visibleOnly || !i.closest('[hidden], .kbp-hidden-option'); });
  }
  function valueOf(pos) {
    var ins = inputsFor(pos, false);
    if (!ins.length) return null;
    if (ins[0].tagName === 'SELECT') return ins[0].value;
    var c = ins.filter(function (i) { return i.checked; })[0];
    return c ? c.value : null;
  }
  function choose(pos, val) {
    var ins = inputsFor(pos, true);
    if (!ins.length) return;
    if (ins[0].tagName === 'SELECT') { ins[0].value = val; ins[0].dispatchEvent(new Event('change', { bubbles: true })); return; }
    var r = ins.filter(function (i) { return i.value === val; })[0];
    if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
  }
  // If the chosen mix of options does not exist (for example a longer handle only comes with one hole centre),
  // switch the OTHER options to the closest mix that does exist, so the customer never has to hunt for it.
  function autoAdjust(changedPos) {
    if (adjusting) return;
    var data = productData();
    if (!data || !data.variants) return;
    var n = (data.options || []).length, vals = {}, p;
    for (p = 1; p <= n; p++) vals[p] = valueOf(p);
    var exact = data.variants.filter(function (v) { for (var q = 1; q <= n; q++) { if (v['option' + q] !== vals[q]) return false; } return true; })[0];
    if (exact) return;
    var visible = {}; for (p = 1; p <= n; p++) visible[p] = inputsFor(p, true).length > 0;
    var cands = data.variants.filter(function (v) {
      if (!v.available || v['option' + changedPos] !== vals[changedPos]) return false;
      for (var q = 1; q <= n; q++) { if (!visible[q] && v['option' + q] !== vals[q]) return false; }
      return true;
    });
    if (!cands.length) return;
    function diff(v) { var d = 0; for (var q = 1; q <= n; q++) if (q !== changedPos && visible[q] && v['option' + q] !== vals[q]) d++; return d; }
    cands.sort(function (a, b) { return diff(a) - diff(b); });
    var best = cands[0];
    adjusting = true;
    for (p = 1; p <= n; p++) { if (p !== changedPos && visible[p] && best['option' + p] !== vals[p]) choose(p, best['option' + p]); }
    adjusting = false;
  }
  function updateOptNote() {
    var note = $('[data-kbp-optnote]', root);
    if (note) note.hidden = !root.querySelector('.block-swatch--disabled');
  }

  /* ---------- events ---------- */
  // Add to cart without a colour: stop it before the theme script runs.
  document.addEventListener('click', function (e) {
    if (!needChoice || !root || !e.target.closest) return;
    var btn = e.target.closest('.product-form__add-button');
    if (!btn || !root.contains(btn)) return;
    e.preventDefault(); e.stopImmediatePropagation();
    showColourError();
  }, true);

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kbp-vat]');
    if (!b || !root || !root.contains(b)) return;
    vatMode = b.getAttribute('data-kbp-vat') === 'inc' ? 'inc' : 'ex';
    paintPrice();
  });

  document.addEventListener('change', function (e) {
    if (!root || !e.target.closest) return;
    var any = e.target.closest('.product-form__single-selector');
    if (any && root && root.contains(any) && !any.closest('[data-kbp-colour]') && !any.closest('.kbp-hidden-option')) {
      var pos = parseInt(any.getAttribute('data-option-position'), 10);
      setTimeout(function () { autoAdjust(pos); updateOptNote(); }, 0);
    }
    var radio = e.target.closest('[data-kbp-colour] .product-form__single-selector');
    if (!radio || !root.contains(radio)) return;
    needChoice = false;
    var req = $('[data-kbp-req]', root); if (req) req.hidden = true;
    clearColourError();
    syncColourProp();
  });

  function init() {
    root = $('.kbp[data-section-type="product"]');
    if (!root) return;
    initRange();
    initColour();
    initPrice();
    initSticky();
    initDescription();
    root.addEventListener('variant:changed', function (e) {
      if (e.detail) renderPrice(e.detail.variant);
      updateOptNote();
    });
    updateOptNote();
    setTimeout(updateOptNote, 400);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
